import { render, staticRenderFns } from "./launch-link-v2.vue?vue&type=template&id=480c2fb2&"
import script from "./launch-link-v2.vue?vue&type=script&lang=ts&"
export * from "./launch-link-v2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports